import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { articles } from "@/seo/articles";
import { useTr, useLang } from "@/i18n";

export default function BlogTeaser() {
  const tr = useTr();
  const lang = useLang();
  const latest = articles.slice(0, 3);
  return (
    <section className="py-20 bg-[#080808]" data-testid="blog-teaser-section">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHeading
          eyebrow={tr("blog.eyebrow", "Dal Blog")}
          title={tr("blog.title", "Consigli per il Tuo Evento")}
          accent={tr("blog.accent", "Guide pratiche scritte da chi gli eventi li fa davvero: scelta del DJ, prezzi e musica che funziona in pista.")}
          testid="blog-teaser-heading"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {latest.map((a, i) => (
            <motion.article
              key={a.slug}
              data-testid={`blog-teaser-card-${a.slug}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="gold-frame rounded-xl bg-[#111111] p-7 flex flex-col"
            >
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#BFA45D]">
                {new Date(a.date).toLocaleDateString(lang === "it" ? "it-CH" : lang === "de" ? "de-CH" : "en-GB", { day: "numeric", month: "long", year: "numeric" })}
              </p>
              <h3 className="font-display text-lg font-semibold text-[#F7DE8B] mt-3 leading-snug">
                {a.h1}
              </h3>
              <p className="text-sm text-[#E2C882]/75 leading-relaxed mt-3 flex-1">
                {a.excerpt}
              </p>
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`blog-teaser-link-${a.slug}`}
                className="inline-flex items-center gap-2 mt-5 text-xs font-bold uppercase tracking-[0.15em] text-[#E2B857] hover:text-[#F7DE8B] transition-colors"
              >
                {tr("blog.readMore", "Leggi la guida")} <ArrowRight size={14} />
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
